import { put, takeEvery, call, all, select } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'

// import group services
import { getGroups, postGroup, putGroup, deleteGroup } from '../../services/group'

const getCurrentUser = state => state.user

export function* fetchGroups() {
  try {
    const user = yield select(getCurrentUser)
    const { data } = yield call(() => getGroups(user.token))
    yield put({
      type: actions.FETCH_GROUPS_SUCCESS,
      data,
    })
  } catch (error) {
    yield put({ type: actions.FETCH_GROUPS_ERROR, message: error.message })
  }
}

export function* setGroup(group) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    group.payload.group = JSON.parse(group.payload.group)
    group.payload.groupId = group.payload.group.groupId
    group.payload.groupUid = group.payload.group.groupUid
    group.payload.userId = user.id
    group.payload.userUid = user.uid
    group.payload.companyId = user.suscription.company.id
    group.payload.companyUid = user.suscription.company.uid
    // ajusta los json
    group.payload.datetimedatajson = JSON.parse(group.payload.datetimedatajson)
    group.payload.sysdatajson = JSON.parse(group.payload.sysdatajson)
    group.payload.extradatajson = JSON.parse(group.payload.extradatajson)
    group.payload.operdatajson = JSON.parse(group.payload.operdatajson)

    yield call(() => putGroup(user.token, group.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se han guardado exitósamente los cambios',
    })
    yield put({
      type: actions.FETCH_GROUPS,
    })
  } catch (error) {
    yield put({ type: actions.GROUP_ERROR, message: error.message })
  }
}

export function* addGroup(group) {
  try {
    const user = yield select(getCurrentUser)

    // ajusta los datos
    console.log('payload:', group.payload)
    group.payload.group = JSON.parse(group.payload.group)
    group.payload.groupId = group.payload.group.groupId
    group.payload.groupUid = group.payload.group.groupUid
    console.log('1')
    group.payload.userId = user.id
    group.payload.userUid = user.uid
    console.log('2')
    group.payload.companyId = user.suscription.company.id
    group.payload.companyUid = user.suscription.company.uid
    console.log('3')
    // ajusta los json
    // group.payload.datetimedatajson = JSON.parse( group.payload.datetimedatajson )
    // group.payload.sysdatajson      = JSON.parse( group.payload.sysdatajson )
    // group.payload.extradatajson    = JSON.parse( group.payload.extradatajson )
    // group.payload.operdatajson     = JSON.parse( group.payload.operdatajson )

    yield call(() => postGroup(user.token, group.payload))
    notification.success({
      message: 'Grabado exitoso',
      description: 'Se ha agregado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_GROUPS,
    })
  } catch (error) {
    yield put({ type: actions.GROUP_ERROR, message: error.message })
  }
}

export function* delGroup(group) {
  try {
    const user = yield select(getCurrentUser)
    yield call(() => deleteGroup(user.token, group.payload.uid))
    notification.success({
      message: 'Borrado exitoso',
      description: 'Se ha eliminado exitósamente el producto',
    })
    yield put({
      type: actions.FETCH_GROUPS,
    })
  } catch (error) {
    yield put({ type: actions.GROUP_ERROR, message: error.message })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_GROUPS, fetchGroups),
    takeEvery(actions.GROUP_SET, setGroup),
    takeEvery(actions.GROUP_ADD, addGroup),
    takeEvery(actions.GROUP_DEL, delGroup),
  ])
}
